import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import Loader from 'react-loaders';
import { Link } from 'react-router-dom';
import AnimatedLetters from '../AnimatedLetters';
import Logo from './Logo';
import './index.scss';

const Home = () => {
    const [letterClass, setLetterClass] = useState('text-animate');
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [isFadedIn, setIsFadedIn] = useState(false);
    const containerRef = useRef(null);
    const textZoneRef = useRef(null); 

    const nameArray = ['', 'K', 'h', 'w', 'a', 'h', 'i', 's', 'h'];
    const jobArray = ['A', ' ', 'B', 'A', 'C', 'K', 'E', 'N', 'D', ' ', 'E', 'N', 'G', 'I', 'N', 'E', 'E', 'R'];

    useEffect(() => {
        const timer = setTimeout(() => {
            setLetterClass('text-animate-hover');
        }, window.innerWidth < 768 ? 2000 : 4000);
        return () => clearTimeout(timer);
    }, []);

    
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setIsFadedIn(true);
            if (containerRef.current) {
                containerRef.current.style.opacity = '1';
                containerRef.current.style.transform = 'translateY(0)';
                void containerRef.current.offsetHeight;
            }
            
            if (textZoneRef.current) {
                textZoneRef.current.style.opacity = '1';
                void textZoneRef.current.offsetHeight; 
            }
        }, 1000);
        return () => clearTimeout(timeoutId);
    }, []);

    

    const handleToggleChat = () => {
        setIsChatOpen(!isChatOpen);
    };

    const CustomResponse = ({ previousStep, steps, triggerNextStep }) => {
        const [response, setResponse] = useState('Fetching response...');
        useEffect(() => {
            const fetchResponse = async () => {
                try {
                    const apiResponse = await axios.post(
                        'https://backend-r-portfolio.onrender.com/api/agi',
                        { chat: previousStep.message },
                        { headers: { 'Content-Type': 'application/json' }, timeout: 10000 }
                    );
                    setResponse(typeof apiResponse.data.result === 'object' ? JSON.stringify(apiResponse.data.result, null, 2) : apiResponse.data.result);
                } catch (error) {
                    console.error('Error fetching chat response:', error);
                    setResponse('An error occurred while fetching the response.');
                } finally {
                    triggerNextStep();
                }
            };
            fetchResponse();
        }, [previousStep, triggerNextStep]);

        return (
            <div className="custom-response">
                <pre className="response-text">{response}</pre>
            </div>
        );
    };

    const steps = [
        { id: '1', message: 'Hi! How can I help you?', trigger: 'userInput' },
        { id: 'userInput', user: true, trigger: 'customResponse' },
        { id: 'customResponse', component: <CustomResponse />, waitAction: true, trigger: '1' },
    ];

    return (
        <>
            <div ref={containerRef} className={`container home-page ${isFadedIn ? 'faded-in' : ''}`} style={{ opacity: 0, transform: 'translateY(-10px)', transition: 'opacity 1s ease-out, transform 1s ease-out' }}>
                <div ref={textZoneRef} className="text-zone"> {}
                    <h1 aria-label="Hi, I'm Khwahish, a Backend Engineer">
                        <span className={letterClass}>H</span>
                        <span className={`${letterClass} _12`}>i,</span>
                        <br />
                        <span className={`${letterClass} _13`}>I</span>
                        <span className={`${letterClass} _14`}>'m</span>
                        <AnimatedLetters letterClass={letterClass} strArray={nameArray} idx={15} />
                        <br />
                        <AnimatedLetters letterClass={letterClass} strArray={jobArray} idx={0} />
                    </h1>
                    <h2>I design systems that stay boring under extreme load</h2>
                    <Link to="/contact" className="flat-button"> CONTACT ME </Link>
                </div>
                <Logo />
            </div>

            <Loader type="pacman" className={isFadedIn ? 'loader-hidden' : 'loader-active'} />

            {}
        </>
    );
};

export default Home;